export default {
  TESTS: {
    TITLE: `Reccuring jobs tests`,
    SUMMARY: ``
  },
  START: `Start`,
  LAST_RUN_AT: `Last run at`,
  EXECUTION_TYPE: `Execution type`,
  NOTIFICATION: `Notification type`,
  RECURRENCE: `Recurrence`,
  TEST: `Test`,
  REGULAR: `Regular`,
  CHECKEXPIREDAVAILABILITIES: `Check expired availabilities`,
  CHECKEXPIREDAVAILABILITIES_DESC: `Checks if some employees have an expired availability 7 to 8 days from now, and if they have no valid availability after 8 days.`,
  CHECKEXPIREDAVAILABILITIES_RECURRENCE: `6-7 PM EST/EDT  everyday.`,
  CHECKEXPIREDAVAILABILITIES_NOTIFICATION_TYPE: `email, push notification`,
  CHECKPUNCHINOUT: `Check punch IN et OUT`,
  CHECKPUNCHINOUT_DESC: `Checks if employees have punched in or out of their shift 5 min after it has started or ended.`,
  CHECKPUNCHINOUT_RECURRENCE: `every 5 min.`,
  CHECKPUNCHINOUT_NOTIFICATION_TYPE: `push notification`,
  CHECKUNPUNCHEDSHIFTS: `Check unpunched shifts`,
  CHECKUNPUNCHEDSHIFTS_DESC: `Sends a list of shifts from yesterday that have no punchcard.`,
  CHECKUNPUNCHEDSHIFTS_RECURRENCE: `2-3 AM EST/EDT  everyday`,
  CHECKUNPUNCHEDSHIFTS_NOTIFICATION_TYPE: `email`,
  EXPIRINGATTRIBUTESREMINDERS: `Expired attributes reminder`,
  EXPIRINGATTRIBUTESREMINDERS_DESC: `Sends a reminder to the employee a few days (Defined by the admin) before the expiration of his attribute.`,
  EXPIRINGATTRIBUTESREMINDERS_RECURRENCE: `5-6 PM EST/EDT  everyday.`,
  EXPIRINGATTRIBUTESREMINDERS_NOTIFICATION_TYPE: `email, push notification , sms`,
  AVAILABILITYCUTOFFREMINDER: `Availability cutoff date reminder`,
  AVAILABILITYCUTOFFREMINDER_DESC: `Sends a reminder to the employee 3h to 4h before the cutoff time to submit availabilities.`,
  AVAILABILITYCUTOFFREMINDER_RECURRENCE: `every hour`,
  AVAILABILITYCUTOFFREMINDER_NOTIFICATION_TYPE: ` push notification`,
  SHIFTNOTIFICATION: `Shift reminder`,
  SHIFTNOTIFICATION_DESC: `Sends a reminder to the employee if he is assigne to some shift(s) the next day.`,
  SHIFTNOTIFICATION_RECURRENCE: `6-7 PM EST/EDT  everyday`,
  SHIFTNOTIFICATION_NOTIFICATION_TYPE: `push notification`,
  HAPPYBIRTHDAY: `Happy birthday notification`,
  HAPPYBIRTHDAY_DESC: `Sends a push notification wishing happy birthday to all the employees whose birthday is today.`,
  HAPPYBIRTHDAY_RECURRENCE: `8-9 AM EST/EDT  everyday.`,
  HAPPYBIRTHDAY_NOTIFICATION_TYPE: `push notification`,
  DAILYQUESTIONNAIREREMINDER: `Daily questionnaire reminder`,
  DAILYQUESTIONNAIREREMINDER_DESC: `Sends a reminder to all employees who haven't filled the daily questionnaire within the time defined by the admin (or 24h by default).`,
  DAILYQUESTIONNAIREREMINDER_RECURRENCE: `4-5 PM EST/EDT  everyday.`,
  DAILYQUESTIONNAIREREMINDER_NOTIFICATION_TYPE: `push notification`,
  CHECKEXPIREDHIRINGDATA: `Check expiring hiring data`,
  CHECKEXPIREDHIRINGDATA_DESC: `Sends an email(defined in the company's settings) with a list of all employees with expiring hiring data in X days (defined in company's settings) from now.`,
  CHECKEXPIREDHIRINGDATA_RECURRENCE: `2h-3h AM EST/EDT everyday.`,
  CHECKEXPIREDHIRINGDATA_NOTIFICATION_TYPE: `email`,
  PROJECTEMPLOYEECHANGESNOTIFICATIONS: `Check employees added or removed from a projet`,
  PROJECTEMPLOYEECHANGESNOTIFICATIONS_DESC: `Sends an email to all project managers with a list of all employees removed or added to their project in the last 24h.`,
  PROJECTEMPLOYEECHANGESNOTIFICATIONS_RECURRENCE: `12h-1h AM EST/EDT tous les jours.`,
  PROJECTEMPLOYEECHANGESNOTIFICATIONS_NOTIFICATION_TYPE: `email`,
  UPDATEEXPIREDHIRINGDATA: `HiringData update`,
  UPDATEEXPIREDHIRINGDATA_DESC: `Update automatically the expired hiring data by its fallback (defined in the hiring data form).`,
  UPDATEEXPIREDHIRINGDATA_RECURRENCE: `12h-1h AM EST/EDT everyday.`,
  UPDATEEXPIREDHIRINGDATA_NOTIFICATION_TYPE: `none`,
  SYNCCHATUSERSTOTWILIO: `Sync chat users to twilio`,
  SYNCCHATUSERSTOTWILIO_DESC: `Sends all users from the chat to twilio.`,
  SYNCCHATUSERSTOTWILIO_RECURRENCE: `12h-1h AM EST/EDT everyday.`,
  SYNCCHATUSERSTOTWILIO_NOTIFICATION_TYPE: `none`,
  INTERCOMEVENTS: `Sync employees data with intercom`,
  INTERCOMEVENTS_DESC: `Sync employees data with intercom.`,
  INTERCOMEVENTS_RECURRENCE: `12h-1h AM EST/EDT everyday.`,
  INTERCOMEVENTS_NOTIFICATION_TYPE: `none`,
  WORKDAYSYNCSCHEDULE: `Sync Workday schedule with Merinio`,
  WORKDAYSYNCSCHEDULE_DESC: `Sync Workday schedule with Merinio.`,
  WORKDAYSYNCSCHEDULE_RECURRENCE: `12h-1h AM EST/EDT everyday.`,
  WORKDAYSYNCSCHEDULE_NOTIFICATION_TYPE: `none`,
  ADDINTEGRATIONJOBS: `Trigger integrations`,
  ADDINTEGRATIONJOBS_DESC: `Run all the integrations.`,
  ADDINTEGRATIONJOBS_RECURRENCE: `every 15 min.`,
  ADDINTEGRATIONJOBS_NOTIFICATION_TYPE: `none`,
  FOLKSRHSYNCUSERS: 'Sync users from FolksrH',
  FOLKSRHSYNCUSERS_DESC: 'Sync users from FolksrH',
  FOLKSRHSYNCUSERS_NOTIFICATION_TYPE: 'none',
  FOLKSRHSYNCUSERS_RECURRENCE: 'every 10 min.',
  CHANGESTATUSOFREPORT: `Change status of stuck pending or processing reports`,
  CHANGESTATUSOFREPORT_DESC: `Change status of stuck "pending" or "processing" reports to "failed" status after 24h`,
  CHANGESTATUSOFREPORT_RECURRENCE: `1-2 AM EST/EDT  everyday`,
  CHANGESTATUSOFREPORT_NOTIFICATION_TYPE: `none`,
  CREATEBILLINGLOGS: `Create billing logs`,
  CREATEBILLINGLOGS_DESC: `Runs createBillingLogs checking billable users`,
  CREATEBILLINGLOGS_RECURRENCE: `6 AM everyday`,
  CREATEBILLINGLOGS_NOTIFICATION_TYPE: `none`,
  CREATEBILLINGLOGSOLD: `Create billing logs (old)`,
  CREATEBILLINGLOGSOLD_DESC: `Runs createBillingLogsOld checking billable users`,
  CREATEBILLINGLOGSOLD_RECURRENCE: `6 AM everyday`,
  CREATEBILLINGLOGSOLD_NOTIFICATION_TYPE: `none`,
  RESETBILLABLETHISMONTH: `Reset billableThisMonth`,
  RESETBILLABLETHISMONTH_DESC: `Set billableThisMonth to false for all users`,
  RESETBILLABLETHISMONTH_RECURRENCE: `5 AM 1st day of month`,
  RESETBILLABLETHISMONTH_NOTIFICATION_TYPE: `none`
}
